import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../../components/styled-components/loader/loader";
import PhoneNumber from "../../components/form/components/Countrycode";
import { Button } from "../../components/button/Button";
import { Input } from "../../components/input/Input";
import { InputGroup } from "../../components/inputGroup/InputGroup";
import Base64 from "../../utils/base64";
import axios from "axios";
import ROUTES from "../../config/routes";
import swal from "sweetalert";

export const VerifyForget = (props) => {
  const history = useHistory();
  const [userData, setUserData] = useState({});

  const [loading, setLoading] = useState(false);
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleForget();
    }
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setUserData({ ...userData, [name]: value });
  };
  const handleForget = async () => {
    console.log("newww", userData, props.otp);
    if (userData.password !== userData.confirmPassword) {
      swal("Oops!", "Passwords do not match", "error");
    } else if (userData && userData.password) {
      const payload = {
        otp: props && props.otp,
        password: userData && userData.password,
        confirmPassword: userData && userData.confirmPassword,
      };
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/reset-password`,
          payload,
          config
        );
        setLoading(false);
        if (res.status === 200 && res.data) {
          swal("Success", res.data.message, "success");
          history.push("/login");
        }
        console.log("res.status", res);
        if (res.status === 400) {
          props.stepState(3);
        }
      } catch (error) {
        setLoading(false); 
        console.log("error in veify", error.response);
        swal(
          "Oops!",
          error.response && error.response.data && error.response.data.message,
          "error"
        );
        props.stepState(3);
      }
    } else {
      swal("Oops!", props && !props.otp && "Please enter a valid OTP", "error");
    }
  };
  return (
    <div style={{ marginTop: "20px" }}>
      <div className="login-card border">
        <h2 className="login-heading">Enter Password</h2>
        <div>
          <InputGroup>
            <label>Password</label>
            <Input
              onChange={handleInputChange}
              id="Password"
              type="text"
              placeholder="Password"
              name="password"
            ></Input>
          </InputGroup>
          <InputGroup>
            <label>Confirm Password</label>
            <Input
              onChange={handleInputChange}
              id="Password"
              type="text"
              onKeyPress={handleKeyPress}
              placeholder="Password"
              name="confirmPassword"
            ></Input>
          </InputGroup>
          <Button
            style={{ background: "#2A3DA3" }}
            onClick={() => {
              handleForget();
            }}
          >
            Update Password
          </Button>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
            }}
          ></div>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
  );
};
